import { ApplicationElement, html } from '@effectivastudio/lit-components';
import style from './style.lit.css';
import '@effectivastudio/lit-components/components/avatar/element.js';
import '@effectivastudio/lit-components/components/icon/element.js';

/**
 * Component that links to a group or a group-joining page, with details about the group. The group's name goes into a default slot
 *
 * @prop favoriteOn - Adds or removes option of marking the group as favorite (optional)
 * @prop favoriteValue - When true, indicates group is marked as favorite (optional)
 * @prop image - Group's avatar image (optional)
 * @prop type - Type of the current group (options: , open, private, closed) (optional)
 * @prop url - Group's destination url
 * @prop subgroupsUrl - Subgroup's destination url (optional)
 * @prop name - Internal property => Will be derived from the slot
 *
 * @slot default - For the title
 *
 * @cssprop --height - Component height
 * @cssprop --avatar-size - Avatar size
 * @cssprop --bg - Component background
 * @cssprop --bg-hover - Component background on hover
 * @cssprop --bg-active - Component background on clicked
 * @cssprop --icon-bg-hover - Icon background on hover
 * @cssprop --icon-bg-active - Icon background on clicked
 */

export default class GroupItem3 extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    favoriteOn: { type: Boolean },
    favoriteValue: { type: Boolean },
    image: { type: String },
    type: { type: String },
    url: { type: String },
    subgroupsUrl: { type: String },
    name: { state: true },
  };

  /** @internal */
  static TYPE_ICON_NAMES = {
    closed: 'lock-keyhole',
    private: 'user-lock',
    open: 'unlock-keyhole',
  };

  /** @internal */
  get typeIcon() {
    return this.constructor.TYPE_ICON_NAMES[this.type];
  }

  renderType() {
    return html`<ef-icon class="icon" name=${this.typeIcon}></ef-icon>`;
  }

  renderSubgroups() {
    return html`
      <a class="button-icon" href=${this.subgroupsUrl}>
        <ef-icon name="users"></ef-icon>
      </a>
    `;
  }

  renderFavorite() {
    return html`
      <ef-icon class="icon" name=${this.favoriteValue ? 'star:solid' : 'star'}>
      </ef-icon>
    `;
  }

  renderActions() {
    return html`
      <div class="actions">
        ${this.type ? this.renderType() : null}
        ${this.subgroupsUrl ? this.renderSubgroups() : null}
        ${this.favoriteOn ? this.renderFavorite() : null}
        <slot name="actions"></slot>
      </div>
    `;
  }

  onSlotChange() {
    this.name = this.innerText;
  }

  render() {
    return html`
      <aside>
        <ef-avatar .name=${this.name} .picture=${this.image}></ef-avatar>
      </aside>
      <main>
        <a href=${this.url}>
          <slot @slotchange=${this.onSlotChange}></slot>
        </a>
        ${this.renderActions()}
      </main>
    `;
  }
}

GroupItem3.registerTagName('xs-group-item-3');

customElements.get('xs-group-item-3') ||
  customElements.define('xs-group-item-3', GroupItem3);
